import { render, staticRenderFns } from "./ViewerOverlayCallView.vue?vue&type=template&id=270d6212&scoped=true"
import script from "./ViewerOverlayCallView.vue?vue&type=script&lang=js"
export * from "./ViewerOverlayCallView.vue?vue&type=script&lang=js"
import style0 from "./ViewerOverlayCallView.vue?vue&type=style&index=0&id=270d6212&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270d6212",
  null
  
)

export default component.exports